export const layout = {

    namespaced: true,

    state:
    {
        sidebarOpen: true,
    },

    mutations:
    {
        setSidebar: (state, bool) =>
        {
            state.sidebarOpen = bool;
        },
    },

    actions:
    {
        toggleSidebar({ commit, getters })
        {
            const body = document.body;

            if (getters.sidebarOpen)
            {
                body.classList.add('sidebar-hide');

                commit('setSidebar', false);
            }
            else
            {
                body.classList.remove('sidebar-hide');

                commit('setSidebar', true);
            }
        },

        minimizeSidebar({ commit })
        {
            commit('setSidebar', {bool: false });

            const body = document.body;

            body.classList.add('sidebar-hide');
        },

        maximizeSidebar({ commit })
        {
            commit('setSidebar', {bool: true });

            const body = document.body;

            body.classList.remove('sidebar-hide');
        },
    },

    getters:
    {
        sidebarOpen: state => state.sidebarOpen,

    },
};
